import axios from 'axios';

export default {
  getAddress (queryParams) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, queryParams, {
        auth_key: '8VJggHrJCPnTysnn'
      });

      return axios.get('https://api.pro6pp.nl/v1/autocomplete', { params }).then(response => {
        const data = response.data;
        resolve(data)
      }).catch(error => {
        reject(error);
      })
    });
  }
}
